import { makeObservable, observable, action, computed } from 'mobx'
import axios, { AxiosError } from 'axios'
import { config } from '@/lib/config'

// Set axios defaults for cookie authentication
axios.defaults.withCredentials = true

export enum OperationState {
  INITIAL = 'INITIAL',
  RUNNING = 'RUNNING',
  DONE = 'DONE',
  ERROR = 'ERROR',
}

export class BaseStore {
  state: OperationState = OperationState.INITIAL
  error: string | null = null

  constructor() {
    makeObservable(this, {
      state: observable,
      error: observable,
      setState: action,
      setError: action,
      isLoading: computed,
      hasError: computed
    })
  }

  setState(state: OperationState) {
    this.state = state
  }

  setError(error: string | null) {
    this.error = error
  }

  get isLoading() {
    return this.state === OperationState.RUNNING
  }

  get hasError() {
    return this.state === OperationState.ERROR
  }

  apiPath(path: string) {
    return `${config.apiBaseUrl}/${path}`
  }

  generateFetchHeader() {
    return {
      'Content-Type': 'application/json',
    }
  }


  async handleApiCall<T>(apiCall: () => Promise<T>): Promise<T | null> {
    this.setState(OperationState.RUNNING)
    this.setError(null)

    try {
      const result = await apiCall()
      this.setState(OperationState.DONE)
      return result
    } catch (error) {
      this.setState(OperationState.ERROR)
      if (error instanceof AxiosError) {
        this.setError(error.response?.data?.message || error.message)
      } else if (error instanceof Error) {
        this.setError(error.message)
      } else {
        this.setError('An unknown error occurred')
      }
      console.error('API call failed:', error)
      return null
    }
  }

  tryShowToast(message: string, type: 'success' | 'error' | 'info' | 'warning') {
    // TODO: Implement toast notification using shadcn/ui
    console.log(`[${type.toUpperCase()}] ${message}`)
  }
}